import "./styles/levdc.css";

import Hero from "./01_hero";
import Variants from "./02_variants";
import Compatibility from "./03_compatibility";
import Specs from "./04_specs";
import Highlights from "./05_highlights";
import UseCases from "./06_usecases";
import WhyLevDc from "./07_whyLevDc";
import ProofBand from "./08_proofBand";
import Cta from "./09_cta";

// NOTE: no <nav>/<footer> here on purpose — this page uses your global
// site Navbar/Footer (per your choice), not its own. In your router,
// wrap the route the same way as your other pages:
//   <Route path="/lev-dc-charger" element={<ViewWithNavbar children={<LevDc />} />} />
//
// The original HTML's own nav (with anchor links to #variants,
// #compatibility, etc.) and hamburger/mobile-menu were dropped along with
// its scroll-spy script — none of that is needed since your global
// Navbar handles site navigation. The in-page section IDs (id="variants",
// id="specs", etc.) are all still here, so any button/link using
// href="#specs" style anchors still works, wherever it points from.
//
// FONTS: see the note at the bottom of styles/levdc.css — add the Syne /
// Outfit / Lora <link> tags to public/index.html once.

export default function LevDc() {
  return (
    <div className="levdc !font-gilroy">
      <Hero />
      <Variants />
      <Compatibility />
      <Specs />
      <Highlights />
      <UseCases />
      <WhyLevDc />
      <ProofBand />
      <Cta />
    </div>
  );
}
